/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RequestVehicleMediaStreamCredentialsMutationVariables =
  Types.Exact<{
    input: Types.RequestVehicleMediaStreamCredentialsInput
  }>

export type RequestVehicleMediaStreamCredentialsMutation = {
  __typename?: 'Mutation'
  requestVehicleMediaStreamCredentials: {
    __typename?: 'VehicleMediaStreamCredentials'
    meetingType: Types.MediaStreamPlatform
    chime: any | null
    livekit: {
      __typename?: 'LiveKitMediaStreamCredentials'
      url: string
      token: string
    } | null
  }
}

export const RequestVehicleMediaStreamCredentialsDocument = gql`
    mutation requestVehicleMediaStreamCredentials($input: RequestVehicleMediaStreamCredentialsInput!) {
  requestVehicleMediaStreamCredentials(input: $input) {
    meetingType
    chime
    livekit {
      url
      token
    }
  }
}
    `
export type RequestVehicleMediaStreamCredentialsMutationFn =
  Apollo.MutationFunction<
    RequestVehicleMediaStreamCredentialsMutation,
    RequestVehicleMediaStreamCredentialsMutationVariables
  >

/**
 * __useRequestVehicleMediaStreamCredentialsMutation__
 *
 * To run a mutation, you first call `useRequestVehicleMediaStreamCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVehicleMediaStreamCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVehicleMediaStreamCredentialsMutation, { data, loading, error }] = useRequestVehicleMediaStreamCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestVehicleMediaStreamCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestVehicleMediaStreamCredentialsMutation,
    RequestVehicleMediaStreamCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestVehicleMediaStreamCredentialsMutation,
    RequestVehicleMediaStreamCredentialsMutationVariables
  >(RequestVehicleMediaStreamCredentialsDocument, options)
}
export type RequestVehicleMediaStreamCredentialsMutationHookResult = ReturnType<
  typeof useRequestVehicleMediaStreamCredentialsMutation
>
export type RequestVehicleMediaStreamCredentialsMutationResult =
  Apollo.MutationResult<RequestVehicleMediaStreamCredentialsMutation>
export type RequestVehicleMediaStreamCredentialsMutationOptions =
  Apollo.BaseMutationOptions<
    RequestVehicleMediaStreamCredentialsMutation,
    RequestVehicleMediaStreamCredentialsMutationVariables
  >
